<template>
  <div class="container">
    <div class="weui-navbar daojia-navbar">
      <div class="daojia-navbar-left"><span class="icon-chevron-left" @click="goto('/')"></span></div>
      <h1 class="daojia-navbar-middle daojia-navbar-middle_logo"><a href="#"><img
            src="../../assets/img/global/logo.png"></a></h1>
      <div class="daojia-navbar-right">
      </div>
    </div>
    <div class="image-box">
      <div class="TitleBackg">
        <div class="weui-flex__item">
          <h1>行李邮寄回国</h1>
          <div>
            <p>取件+分拣+打包+邮寄</p>
            <p>到家全服务，行李轻松回国</p>
          </div>
        </div>
      </div>
      <div class="multiLineImg">
        <div class="item">
          <div class="weui-flex">
            <div class="weui-flex__item img">
              <img :src="'../../../static/img/baggage/icon/customerService.png'">
            </div>
            <div class="weui-flex__item img">
              <img :src="'../../../static/img/baggage/icon/price.png'">
            </div>
            <div class="weui-flex__item img">
              <img :src="'../../../static/img/baggage/icon/Pro.png'">
            </div>
            <div class="weui-flex__item img">
              <img :src="'../../../static/img/baggage/icon/excuse.png'">
            </div>
          </div>
          <div class="weui-flex quality">
            <div class="weui-flex__item">
              <div>专业客服</div>
            </div>
            <div class="weui-flex__item">
              <div>价格透明</div>
            </div>
            <div class="weui-flex__item">
              <div>品质服务</div>
            </div>
            <div class="weui-flex__item">
              <div>全面保障</div>
            </div>
          </div>
        </div>
      </div>
      <img src='/static/img/baggage/B_04.jpg'>
      <img src='/static/img/baggage/B_05.jpg'>
      <!-- <img  @click="$router.push('/baggage-price');" src='/static/img/baggage/B_07.jpg'> -->
      <div class="weui-flex filling" @click="$router.push('/baggage-info');">
        <div class="weui-flex__item precautions">
          <p>查看注意事项</p>
        </div>
      </div>
      <div class="weui-flex filling" @click="$router.push('/baggage-warn');">
        <div class="weui-flex__item precautions">
          <p>查看邮寄服务禁运物品详情</p>
        </div>

      </div>
      <div class="daojia-ShippingMethod filling">
        <h2>多种邮寄方式</h2>
        <div>
          <span class="Diamond"></span>
          <h3>绿色专线</h3>
          <div class="item" @click="$router.push('/baggage-price');">
            <img src="../../../static/img/baggage/B_07_1.jpg">
            <div class="text-div weui-flex">
              <div class="pull-left weui-flex__item">10-20个工作日到达</div>
              <div class="pull-right weui-flex__item">查看更多<span class="icon-chevron-right"></span></div>
            </div>
          </div>
        </div>
        <div>
          <span class="Diamond"></span>
          <h3>Aupost代寄</h3>
          <div class="item" @click="$router.push('/baggage-price');">
            <img src="../../../static/img/baggage/B_07_2.jpg">
            <div class="text-div weui-flex">
              <div class="pull-left weui-flex__item">
                一个月到达
              </div>
              <div class="pull-right weui-flex__item">
                查看更多<span class="icon-chevron-right"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="space"></div>
    </div>
    <div class="js_dialog" v-show="isLeaving">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd"><strong class="weui-dialog__title">订单尚未完成</strong></div>
        <div class="weui-dialog__bd">确定要回到首页吗？回去后将丢失当前下单进度</div>
        <div class="weui-dialog__ft">
          <div class="weui-dialog__btn weui-dialog__btn_default" @click="isLeaving = false">取消</div>
          <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="goto('/')">回到首页</div>
        </div>
      </div>
    </div>
    <div class="btn-box-fix">
      <div class="slogan">点击查看
        <span class="color-orange">
          <span @click="$router.push('/baggage-price');">收费详情及更多介绍</span>
        </span>
      </div>
      <div class="btn-container">
        <a href="javascript:void(0)" class="btn active" @click="orderUpdateAll('/baggage-calc')">开始下单</a>
      </div>
    </div>

    <img :src="pixelURL('cangchu', 'jieshao')" class="hide">
</div>
</template>

<script>
export default {
  name: 'step1',
  data() {
    return {
      order: {
        service: 'baggage',
        data: {
          service_date: "",
          service_period: "",
          vehicle_type: "",
          out_name: "",
          out_phone: "",
          out_street: "",
          out_suburb: "",
          out_state: "NSW",
          out_postcode: "",
          out_floor: "",
          out_parking: "",
          out_unit: "",
          email: "",
          in_name: "快递公司",
          in_phone: "0477747777",
          in_street: "1/81 St Hilliers Road",
          in_suburb: "Auburn",
          in_state: "NSW",
          in_postcode: "2144",
          in_floor: "1",
          in_parking: "1",
          home_address: [
            {
              home_name: "",
              home_phone: "",
              home_address: "",
            },
          ],
          agency: "",
          msg: "",
          coupon_title: "",
          coupon_id: "",
          couponLocked: "",
          couponValue: 0,
          boxQty: 1
        },
        temp: {
          isAM: '',
          isPM: '',
          isDate: '',
          timeTable: {}
        },
      },
      isLeaving: false
    }
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if (localParsed.service == "baggage") {
        this.order = localParsed;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container {
  padding-top: 50px;
}

.title {
  font-size: 1.4em;
}

.empty {
  padding: 0 20vw;
  text-align: center;
  margin-top: 2vh;
  width: 100vw;
  box-sizing: border-box;
  color: #999;

  a {
    color: #fe9567;
  }
}

.image-box {
  img {
    width: 100%;
  }

  font-size:0;
}

.btn {
  margin-top: 20px;
}

.text {
  text-align: center;
  font-size: 1.2em;
  color: #888;
}

.slogan {
  margin-top: 6px;
  margin-bottom: 5px;
  font-size: 0.8em;
}

.btn-box-fix .btn.active {
  margin-left: 0;
  margin-top: 0;
}

.filling {
  padding: 10px 20px 10px 20px;
  margin: 0 0 10px 0;
  -webkit-box-align: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;

  img {
    width: 100%;
  }
}

.daojia-navbar {
  position: fixed;
  background: rgba(255, 255, 255, 0.95);
  padding: 8px 10px;
  box-sizing: border-box;
  height: 50px;
}

.daojia-navbar-left {
  display: block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  text-align: left;

  span {
    font-size: 2em;
    color: #666;
  }
}

.daojia-navbar-middle_logo img {
  height: 34px;
}

.daojia-navbar-middle {
  display: block;
  -webkit-box-flex: 2;
  -webkit-flex: 2;
  flex: 2;
  font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-family: sans-serif;
  font-size: 1.2em;
  line-height: 1.3;
  font-weight: bold;
}

.daojia-navbar-right {
  font-size: 14px;
  line-height: 26px;
  display: block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  text-align: right;
}

.TitleBackg {
  background-size: cover;
  background-position: center;
  padding: 10vh 30px 10vh 30px;
  color: #f7f7f7;
  text-align: center;
  font-size: 3.5vw;
  background-image: url(../../../static/img/baggage/B_2_1.jpg);

  h1 {
    font-size: 7vw;
    line-height: 40px;
    padding-bottom: 10px;
  }

  p {
    font-size: 3.5vw;
    padding-top: 20px;
    padding: 0 0 0 0;
  }
}

.precautions {
  justify-content: center;
  align-items: center;
  background-color: #f7f8fd;
  border: 2px solid #ff7f50;
  border-radius: 20px;
  border: 2px dotted #ff7444;
  padding: 10px 20px;
  text-align: center;
  font-size: 16px;
  width: 60vw;
  margin-bottom: 20px;
  ;
}

.daojia-ShippingMethod {
  height: 40vh;

  h2 {
    font-size: 6.5vw;
    color: #60636c;
    text-align: center;
    padding-bottom: 20px;
  }

  h3 {
    font-size: 4vw;
    color: #ff7444;
    border: 1px #ff7444 solid;
    display: inline-block;
    padding: 0 0.4em 0 0.4em;

  }

  .Diamond {
    position: relative;
  }

  .Diamond::before {
    content: "";
    display: inline-block;
    width: 3vw;
    height: 3vw;
    background: #ff7444;
    transform: rotate(45deg);
    margin-right: 10px;
  }

  .item {
    padding: 10px 0 35px 0;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .text-div {
    height: 10vw;
    background-color: #ff7444;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    align-items: center;
    text-align: left;
    width: 100%;
    color: white;
    font-size: 3.5vw;
  }

  .pull-left {
    padding-left: 20px;
  }

  .pull-right {
    padding-right: 20px;
    text-align: right;
  }
}

.multiLineImg {
  padding: 20px 0px 20px 0px;
  color: #666;


  .img {
    display: flex;
    justify-content: center;
    /*水平居中*/
    align-items: center;
    padding-bottom: 10px;
  }

  img {
    width: 10.5vw;
    height: 10.5vw;
  }

  .quality {
    width: 100%;
    text-align: center;
    font-size: 3.4vw;
    color: #5A5E68;
  }
}



.space {
  padding-top: 16vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/baggage/step1.vue